import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledButton } from 'src/components/app-components/StyledButton';
import useLocales from 'src/hooks/useLocales';

type Lang = "ja" | "en";

interface Action5ErrorContentEntity {
  errorList: {
    errorMessage: Record<Lang, string>;
    title?: string,
    value?: string,
  }[];
  onCloseFunc: () => void;
}

//エラーレポート詳細

const Action5ErrorContent: React.FC<Action5ErrorContentEntity> = ({ errorList, onCloseFunc }) => {
  const { t } = useTranslation();
  const { currentLang } = useLocales();
  //スタイル
  const styles = {
    px: 5,
    py: 2,
    overflowY: 'scroll',
    maxHeight: '30ch',
  };
  
  return (
    <>
      <Stack>
        {errorList !== undefined && errorList.length === 0 ? (
          <Typography variant={'body1'} sx={{ textAlign: 'center' }} children={t('errorReport.message.emptyError')} />
        ) : <Box sx={styles}>
          {errorList.map((v, i) => (
            <Typography key={i} variant={'body1'} children={v.errorMessage[currentLang.value as Lang]} />
          ))}
        </Box>}
      </Stack>
      <Stack sx={{ mt: 5 }}>
        <StyledButton onClick={onCloseFunc} children={t('button.close')} />
      </Stack>
    </>
  );
};

export default Action5ErrorContent;

